import React, { FC } from 'react';
import { useHistory } from 'react-router-dom';
import { Header } from 'semantic-ui-react';
import { Button } from '..';
import useWindowSize from '../../../hooks/useWindowSize';
import { Pane } from '../../layout/Pane';

interface Props {
  message: string;
  onClick?: () => void;
}

const UpgradeNow: FC<Props> = ({ message, onClick, ...rest }) => {
  const history = useHistory();
  const { isMobile } = useWindowSize();

  return (
    <Pane
      marginBottom="5vh"
      alignItems="center"
      flexDirection={isMobile ? 'column' : 'row'}
      background="redTint"
      padding={16}
      display="flex"
      {...rest}>
      <Pane flex={1}>
        <Header as="h4">{message}</Header>
      </Pane>
      {isMobile && <Pane height="0.8rem" />}
      <Button
        primary
        borderRadius="0px"
        onClick={
          onClick || (() => history.push('/user/settings/subscription'))
        }>
        Upgrade Now
      </Button>
    </Pane>
  );
};

export default UpgradeNow;
